import JOYAJOY_CreateGame_v4_EN from '../assets/graphics/video/JOYAJOY_CreateGame_v4_EN_20241025v1_smal.mp4';
import JOYAJOY_CreateGame_v4_SC from '../assets/graphics/video/JOYAJOY_CreateGame_v4_SC_20241031v1_small.mp4';
import JOYAJOY_CreateGame_v4_TC from '../assets/graphics/video/JOYAJOY_CreateGame_v4_TC_20241025v1_small.mp4';
import JOYAJOY_GuaranteedLearning_v5_EN from '../assets/graphics/video/JOYAJOY_GuaranteedLearning_v5_EN-US_20241025v1_small.mp4';
import JOYAJOY_GuaranteedLearning_v5_SC from '../assets/graphics/video/JOYAJOY_GuaranteedLearning_v5_SC_20241025v1_small.mp4';
import JOYAJOY_GuaranteedLearning_v5_TC from '../assets/graphics/video/JOYAJOY_GuaranteedLearning_v5_TC-TW_20241025v1_small.mp4';

export const Videos = {
  //JOYAJOY
  JOYAJOY_CreateGame_v4_EN,
  JOYAJOY_CreateGame_v4_SC,
  JOYAJOY_CreateGame_v4_TC,
  JOYAJOY_GuaranteedLearning_v5_EN,
  JOYAJOY_GuaranteedLearning_v5_SC,
  JOYAJOY_GuaranteedLearning_v5_TC,
};

export const getCreateGameVideo = (lang: string) => {
  switch (lang) {
    case 'zh-CN':
      return Videos.JOYAJOY_CreateGame_v4_SC;
    case 'zh':
    case 'zh-TW':
      return Videos.JOYAJOY_CreateGame_v4_TC;
    case 'ja':
      return Videos.JOYAJOY_CreateGame_v4_EN;
    case 'en':
    default:
      return Videos.JOYAJOY_CreateGame_v4_EN;
  }
};

export const getGuaranteedLearningVideo = (lang: string) => {
  switch (lang) {
    case 'zh-CN':
      return Videos.JOYAJOY_GuaranteedLearning_v5_SC;
    case 'zh':
    case 'zh-TW':
      return Videos.JOYAJOY_GuaranteedLearning_v5_TC;
    case 'ja':
      return Videos.JOYAJOY_GuaranteedLearning_v5_EN;
    case 'en':
    default:
      return Videos.JOYAJOY_GuaranteedLearning_v5_EN;
  }
};
